import { useContext, useEffect, useState } from "react";
import { Card, Icon, Slide } from "@mui/material";
import { gql, useMutation } from "@apollo/client";
import Footer from "components/Footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import { MessageManager } from "context";
import { UserContext } from "context/user";
import SinDatos from "components/Carteles/SinDatos";
import PageLayout from "components/LayoutContainers/EmpleadoLayout";
import { getUproColor } from "utils/colors";
import { esTeclaDeCodigo, leerTokenQrPedido } from "utils/qrPedido";

const SCANEAR_PEDIDO = gql`
  mutation scannearPedido($token: String!, $estado: String!) {
    scannearPedido(token: $token, estado: $estado)
  }
`;

function PantallaScaner() {
  const [scannearPedido] = useMutation(SCANEAR_PEDIDO);
  const [scannedCode, setScannedCode] = useState("");
  const [status, setStatus] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);

  useEffect(() => {
    let code = "";

    const handleKeyPress = (e) => {
      if (e.key === "Enter") {
        if (code) {
          setScannedCode(leerTokenQrPedido(code));
          code = ""; // Reiniciar después del escaneo
        }
      } else if (esTeclaDeCodigo(e.key)) {
        code += e.key; // Acumular caracteres
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, []);

  useEffect(() => {
    if (!scannedCode) return;

    scannearPedido({
      variables: { token: scannedCode, estado: "RESERVADO" },
    })
      .then((data) => {
        setStatus("success");
        setSuccessMsg(data?.data?.scannearPedido);
      })
      .catch((error) => {
        console.error(error?.message);
        setStatus("error");
        setErrorMsg(error?.message);
      })
      .finally(() => {
        setScannedCode(""); // Limpiar el código después de procesarlo
      });
  }, [scannedCode, scannearPedido]);

  useEffect(() => {
    if (!status) return;
    const timeoutId = setTimeout(() => setStatus(null), 7000);
    return () => clearTimeout(timeoutId);
  }, [status]);
  return (
    <PageLayout background="#f3f3f3">
      <SoftBox display="grid" gridTemplateColumns="1fr" gap={1} alignItems="start">
        <SoftBox display="flex" flexDirection="column" justifyContent="flex-start">
          <SoftBox p={2} mt={2}>
            <Card sx={{ padding: 1, marginBottom: 2 }}>
              <SoftTypography variant="h6" align="center">
                Entrega de pedidos
              </SoftTypography>
              <SoftButton
                variant="contained"
                color="primary"
                onClick={() =>
                  setScannedCode(
                    "0d8bc0db3b620541771f550ac8a52eeeb16ce8622cd2b5ea0961ebbc9069de96c1fa938e2a6608a85d454f9658f9a71adb651ae799c43067a823a39677ae3d1a"
                  )
                }
              >
                Simular entrega de pedido
              </SoftButton> 
            </Card>

            {status === "success" ? (
              // <Card sx={{ backgroundColor: "#74f806" }}>
              //   <SinDatos
              //     titulo="Pedido entregado"
              //     mensaje={successMsg || "El pedido ha sido entregado correctamente."}
              //     icono="check"
              //   />
              // </Card>
              <Card
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  maxHeight: "90%",
                  width: "45%",
                  overflowY: "auto",
                  p: 3,
                }}
              >
                <Slide in={status === "success"} direction="up" mountOnEnter unmountOnExit>
                  <Card>
                    <SoftBox
                      bgColor={getUproColor("uproGreen")}
                      p={3}
                      py={"5rem"}
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      textAlign="center"
                    >
                      <Icon
                        fontSize="large"
                        sx={{
                          color: "#fff",
                          animation: "shakes 1s",
                          "@keyframes shakes": {
                            "0%": {
                              transform: "rotate(0deg)",
                            },
                            "25%": {
                              transform: "rotate(10deg)",
                            },
                            "50%": {
                              transform: "rotate(-20deg)",
                            },
                            "75%": {
                              transform: "rotate(15deg)",
                            },
                            "100%": {
                              transform: "rotate(-5deg)",
                            },
                          },
                        }}
                      >
                        check_circle
                      </Icon>
                      <SoftTypography variant="h5" color="white" fontWeight="bold" mt={2}>
                        Pedido entregado
                      </SoftTypography>
                      <SoftTypography variant="caption" color="white" mt={1}>
                        El pedido ha sido entregado correctamente.
                      </SoftTypography>
                    </SoftBox>
                  </Card>
                </Slide>
              </Card>
            ) : status === "error" ? (
              // <Card sx={{ backgroundColor: "#ee3939" }}>
              //   <SinDatos
              //     titulo="Error al entregar pedido"
              //     mensaje={errorMsg || "Ha ocurrido un error al entregar el pedido."}
              //     icono="error"
              //   />
              // </Card>
              <Card
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  maxHeight: "90%",
                  width: "45%",
                  overflowY: "auto",
                  p: 3,
                }}
              >
                <Slide in={status === "error"} direction="up" mountOnEnter unmountOnExit>
                  <Card>
                    <SoftBox
                      bgColor={getUproColor("uproPink")}
                      p={3}
                      py={"5rem"}
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      textAlign="center"
                    >
                      <Icon
                        fontSize="large"
                        sx={{
                          color: "#fff",
                          animation: "shakes 1s",
                          "@keyframes shakes": {
                            "0%": {
                              transform: "rotate(0deg)",
                            },
                            "25%": {
                              transform: "rotate(10deg)",
                            },
                            "50%": {
                              transform: "rotate(-20deg)",
                            },
                            "75%": {
                              transform: "rotate(15deg)",
                            },
                            "100%": {
                              transform: "rotate(-5deg)",
                            },
                          },
                        }}
                      >
                        error
                      </Icon>
                      <SoftTypography variant="h5" color="white" fontWeight="bold" mt={2}>
                        Error al marcar pedido
                      </SoftTypography>
                      <SoftTypography variant="caption" color="white" mt={1}>
                        {errorMsg || "Ha ocurrido un error al marcar el pedido."}
                      </SoftTypography>
                    </SoftBox>
                  </Card>
                </Slide>
              </Card>
            ) : (
              // <Card>
              //   <SinDatos
              //     titulo="Escanee el código QR"
              //     mensaje="Para verificar su pedido, escanee el código QR del pedido."
              //     icono="qr_code"
              //   />
              // </Card>
              <Card
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  maxHeight: "90%",
                  width: "45%",
                  overflowY: "auto",
                  p: 3,
                }}
              >
                <Slide
                  in={status != "success" && status != "error"}
                  direction="up"
                  mountOnEnter
                  unmountOnExit
                >
                  <Card>
                    <SoftBox
                      bgColor={getUproColor("uproGray")}
                      p={3}
                      py={"5rem"}
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      textAlign="center"
                    >
                      <Icon
                        fontSize="large"
                        sx={{
                          color: "#fff",
                          animation: "shakes 1s infinite",
                          "@keyframes shakes": {
                            "0%": {
                              transform: "rotate(0deg)",
                            },
                            "25%": {
                              transform: "rotate(10deg)",
                            },
                            "50%": {
                              transform: "rotate(-20deg)",
                            },
                            "75%": {
                              transform: "rotate(15deg)",
                            },
                            "100%": {
                              transform: "rotate(-5deg)",
                            },
                          },
                        }}
                      >
                        qr_code
                      </Icon>
                      <SoftTypography variant="h5" color="white" fontWeight="bold" mt={2}>
                        Escanee el código QR
                      </SoftTypography>
                      <SoftTypography variant="caption" color="white" mt={1}>
                        Para verificar su pedido, escanee el código QR del pedido.
                      </SoftTypography>
                    </SoftBox>
                  </Card>
                </Slide>
              </Card>
            )}
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </PageLayout>
  );
}

export default PantallaScaner;
